import { mapState, mapActions, mapMutations } from 'vuex';
import { Howl } from 'howler';
import { randomValue, randomBetween } from '@/lib/random';

function getSoundVolume(sound) {
	const min = (sound.volume - sound.volume_variation) * 100;
	const max = (sound.volume + sound.volume_variation) * 100;
	return randomBetween(min, max) / 100;
}

function soundObjectToArray(src) {
	const srcArray = [];

	if ("webm" in src) {
		srcArray[0] = src.webm;
	}

	if ("mp3" in src) {
		srcArray[0] = src.mp3;
	}

	return srcArray;
}

function createHowl(src, options = {}) {
	let srcArray = src;

	if (!Array.isArray(src)) {
		srcArray = [src];
	}

	const args = { src: srcArray, ...options };

	return new Howl(args);
}

export { getSoundVolume };
export { soundObjectToArray };
export { createHowl };

export default {
	computed: {
		...mapState({
			muted: (state) => state.sound.muted,
			sounds: (state) => state.config.sounds,
			tracks: (state) => state.sound.tracks,
		}),
	},
	methods: {
		...mapMutations(["addTrack", "removeTrack", "initializeTrack"]),
		...mapActions(["registerSound"]),
		playRandomSound(name, options = {}) {
			if (this.soundExists(name) && !this.trackLimitReached(name)) {
				const sound = this.getRandomSound(name);
				const volume = this.getSoundVolume(sound);
				const soundArray = soundObjectToArray(sound);
				const howl = this.createHowl(soundArray, { volume, ...options });
				this.registerSound({ howl, name });
				howl.play();
			}
		},
		soundExists(name) {
			return name in this.sounds && "fx_group" in this.sounds[name];
		},
		trackLimitReached(name) {
			return name in this.tracks && this.sounds[name].limit
				&& this.sounds[name].max < this.tracks[name].length;
		},
		getRandomSound(name) {
			return randomValue(this.sounds[name].fx_group);
		},
		getSoundVolume,
		createHowl,
		soundObjectToArray,
	},
};



// WEBPACK FOOTER //
// ./src/mixins/sound-fx.js